module.exports = __webpack_public_path__ + "f29d484d3f1417d37a069280ceca34af.svg";